import Swiper, { Navigation, Pagination, ScrollBar, Autoplay, EffectFade, A11y } from 'swiper'

class SwiperSlider {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = {
            slidesPerView: 1,
            pagination: false,
            loop: false,
            dontInit: false,
            navigation: false,
            autoplay: false,
            scrollbar: false,
            effect: false,
            ally: true,
            imgHeight: false,
            observer: true,
            observeParents: true,
            ...JSON.parse(this._elem.getAttribute('data-swiper') || '{}')
        }
        this._slider = null
    }
    onInit () {
        if (!this._options.dontInit) {
            Swiper.use([Navigation, Pagination, ScrollBar, Autoplay, EffectFade, A11y])
            this._slider = new Swiper(this._elem, this._options)
            if (this._options.imgHeight) {
                this._imageHeight()
                window.addEventListener('resize', e => {
                    this._imageHeight()
                })
            }
        }
    }
    _imageHeight () {
        let imgs = this._elem.querySelectorAll('img')
        let heightValue = 0
        imgs.forEach(img => {
            let height = img.offsetHeight
            if (height > heightValue) {
                heightValue = height
                const arrows = this._elem.parentNode.querySelectorAll('.slider-arrow')
                arrows.forEach((arrow) => {
                    arrow.style.height = heightValue + 'px'
                })
            }
        })
    }
}

export default SwiperSlider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Swiper.js